import { createContext } from 'react';
import { action, observable } from 'mobx';

class HomeStore {
  @observable premClassesWithEnrollments = [];
}

export default HomeStore;
export const homeContext = createContext(null);
